"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userUpdate = exports.userUnpagedList = exports.userUniqueEmailReset = exports.userUniqueEmail = exports.userTenantPermission = exports.userSuccess = exports.userSoftRestore = exports.userSoftDeletedList = exports.userSoftDelete = exports.userSendEmail = exports.userResetTrasfer = exports.userResetPasswordCommonReset = exports.userResetPasswordCommon = exports.userReset = exports.userListTransfer = exports.userList = exports.userHardDelete = exports.userFetch = exports.userError = exports.userDetails = exports.userDeletedByList = exports.userDeactivateUser = exports.userBulkSoftDeleteRestore = exports.userBulkSoftDelete = exports.userBulkHardDelete = exports.userBulkDeactivate = exports.userBulkActivate = exports.userAuthorizeDevice = exports.userAdminDetails = exports.userAdd = exports.userActivities = exports.userActivateUser = exports.reportUserList = exports.dataUserList = exports.contentUserList = exports.brandUserList = exports.applicationUserList = void 0;
var _user = require("./user.constant");
// common success
var userSuccess = function userSuccess(actionType, data) {
  return {
    type: _user.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.userSuccess = userSuccess;
var userError = function userError(actionType, error) {
  return {
    type: _user.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * Send mail
 * @param payload
 * @returns api response
 * @description this function used send mail for new account.
 */
exports.userError = userError;
var userSendEmail = function userSendEmail(data) {
  return {
    type: _user.actionTypes.SEND_EMAIL,
    payload: data
  };
};

/* add user
 * @param payload
 * @returns api response
 * @description this function used to add user.
 */
exports.userSendEmail = userSendEmail;
var userAdd = function userAdd(data) {
  return {
    type: _user.actionTypes.ADD,
    payload: data
  };
};

/** fetch
 * @param payload
 * @returns api response
 * @description this function used to get user.
 */
exports.userAdd = userAdd;
var userFetch = function userFetch(data) {
  return {
    type: _user.actionTypes.FETCH,
    payload: data
  };
};

/**
 * details
 * @param payload
 * @returns api response
 * @description this function used to get details.
 */
exports.userFetch = userFetch;
var userDetails = function userDetails(data) {
  return {
    type: _user.actionTypes.DETAILS,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
exports.userDetails = userDetails;
var userList = function userList(data) {
  return {
    type: _user.actionTypes.LIST,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
exports.userList = userList;
var userUnpagedList = function userUnpagedList(data) {
  return {
    type: _user.actionTypes.LIST_UNPAGED,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
exports.userUnpagedList = userUnpagedList;
var userListTransfer = function userListTransfer(data) {
  return {
    type: _user.actionTypes.LIST_TRANSFER,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
exports.userListTransfer = userListTransfer;
var brandUserList = function brandUserList(data) {
  return {
    type: _user.actionTypes.BRAND_USER_LIST,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
exports.brandUserList = brandUserList;
var contentUserList = function contentUserList(data) {
  return {
    type: _user.actionTypes.CONTENT_USER_LIST,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
exports.contentUserList = contentUserList;
var applicationUserList = function applicationUserList(data) {
  return {
    type: _user.actionTypes.APPLICATION_USER_LIST,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
exports.applicationUserList = applicationUserList;
var dataUserList = function dataUserList(data) {
  return {
    type: _user.actionTypes.DATA_USER_LIST,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
exports.dataUserList = dataUserList;
var reportUserList = function reportUserList(data) {
  return {
    type: _user.actionTypes.REPORT_USER_LIST,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update user.
 */
exports.reportUserList = reportUserList;
var userUpdate = function userUpdate(data) {
  return {
    type: _user.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete user.
 */
exports.userUpdate = userUpdate;
var userSoftDelete = function userSoftDelete(data) {
  return {
    type: _user.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * hard delete
 * @param payload
 * @returns api response
 * @description this function used to hard delete user.
 */
exports.userSoftDelete = userSoftDelete;
var userHardDelete = function userHardDelete(data) {
  return {
    type: _user.actionTypes.HARD_DELETE,
    payload: data
  };
};

/**
 * soft restore
 * @param payload
 * @returns api response
 * @description this function used to soft restore user.
 */
exports.userHardDelete = userHardDelete;
var userSoftRestore = function userSoftRestore(data) {
  return {
    type: _user.actionTypes.SOFT_RESTORE,
    payload: data
  };
};

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft deleted list.
 */
exports.userSoftRestore = userSoftRestore;
var userSoftDeletedList = function userSoftDeletedList(data) {
  return {
    type: _user.actionTypes.SOFT_DELETE_LIST,
    payload: data
  };
};

/**
 * unique email
 * @param payload
 * @returns api response
 * @description this function used to unique email.
 */
exports.userSoftDeletedList = userSoftDeletedList;
var userUniqueEmail = function userUniqueEmail(data) {
  return {
    type: _user.actionTypes.UNIQUE_EMAIL,
    payload: data
  };
};

/**
 * Reset email is unique or not
 * @param payload
 * @returns api response
 * @description this function used to reset email unique check.
 */
exports.userUniqueEmail = userUniqueEmail;
var userUniqueEmailReset = function userUniqueEmailReset(data) {
  return {
    type: _user.actionTypes.UNIQUE_EMAIL_RESET,
    payload: data
  };
};

/**
 * bulk user delete
 * @param payload
 * @returns api response
 * @description this function used to bulk user delete.
 */
exports.userUniqueEmailReset = userUniqueEmailReset;
var userBulkHardDelete = function userBulkHardDelete(data) {
  return {
    type: _user.actionTypes.BULK_HARD_DELETE,
    payload: data
  };
};

/**
 * bulk user activate
 * @param payload
 * @returns api response
 * @description this function used to bulk user activate.
 */
exports.userBulkHardDelete = userBulkHardDelete;
var userBulkActivate = function userBulkActivate(data) {
  return {
    type: _user.actionTypes.BULK_ACTIVATE,
    payload: data
  };
};

/**
 * bulk user deactivate
 * @param payload
 * @returns api response
 * @description this function used to bulk user deactivate.
 */
exports.userBulkActivate = userBulkActivate;
var userBulkDeactivate = function userBulkDeactivate(data) {
  return {
    type: _user.actionTypes.BULK_DEACTIVATE,
    payload: data
  };
};

/**
 * user activites
 * @param payload
 * @returns api response
 * @description this function used to log user activites.
 */
exports.userBulkDeactivate = userBulkDeactivate;
var userActivities = function userActivities(data) {
  return {
    type: _user.actionTypes.ACTIVITIES,
    payload: data
  };
};

/**
 * user reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.userActivities = userActivities;
var userReset = function userReset(data) {
  return {
    type: _user.actionTypes.RESET,
    payload: data
  };
};

/**
 * user reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.userReset = userReset;
var userResetTrasfer = function userResetTrasfer() {
  return {
    type: _user.actionTypes.RESET_TRANSFER
  };
};

/**
 * Authorize device
 * @param payload
 * @returns api response
 * @description this function used to authorize device.
 */
exports.userResetTrasfer = userResetTrasfer;
var userAuthorizeDevice = function userAuthorizeDevice(data) {
  return {
    type: _user.actionTypes.AUTHORIZE_DEVICE,
    payload: data
  };
};

/**
 * Activate user
 * @param payload
 * @returns api response
 * @description this function used to activate user.
 */
exports.userAuthorizeDevice = userAuthorizeDevice;
var userActivateUser = function userActivateUser(data) {
  return {
    type: _user.actionTypes.ACTIVATE_USER,
    payload: data
  };
};

/**
 * Deactivate user
 * @param payload
 * @returns api response
 * @description this function used to deactivate user.
 */
exports.userActivateUser = userActivateUser;
var userDeactivateUser = function userDeactivateUser(data) {
  return {
    type: _user.actionTypes.DEACTIVATE_USER,
    payload: data
  };
};

/**
 * Reset password common
 * @param payload
 * @returns api response
 * @description this function used to reset passworld its credencials.
 */
exports.userDeactivateUser = userDeactivateUser;
var userResetPasswordCommon = function userResetPasswordCommon(data) {
  return {
    type: _user.actionTypes.RESET_PASSWORD_COMMON,
    payload: data
  };
};

/**
 * Reset password common reset
 * @param payload
 * @returns api response
 * @description this function used to reset passworld its credencials.
 */
exports.userResetPasswordCommon = userResetPasswordCommon;
var userResetPasswordCommonReset = function userResetPasswordCommonReset() {
  return {
    type: _user.actionTypes.RESET_PASSWORD_COMMON_RESET
  };
};

/**
 * Deactivate user
 * @param payload
 * @returns api response
 * @description this function used to deactivate user.
 */
exports.userResetPasswordCommonReset = userResetPasswordCommonReset;
var userTenantPermission = function userTenantPermission(data) {
  return {
    type: _user.actionTypes.TENANT_PERMISSION,
    payload: data
  };
};

/**
 * Deactivate user
 * @param payload
 * @returns api response
 * @description this function used to deactivate user.
 */
exports.userTenantPermission = userTenantPermission;
var userAdminDetails = function userAdminDetails() {
  return {
    type: _user.actionTypes.USER_ADMIN
  };
};

/**
 * bulk user soft delete
 * @param payload
 * @returns api response
 * @description this function used to bulk user soft delete.
 */
exports.userAdminDetails = userAdminDetails;
var userBulkSoftDelete = function userBulkSoftDelete(data) {
  return {
    type: _user.actionTypes.BULK_SOFT_DELETE,
    payload: data
  };
};

/**
 * bulk user soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to bulk user soft delete restore.
 */
exports.userBulkSoftDelete = userBulkSoftDelete;
var userBulkSoftDeleteRestore = function userBulkSoftDeleteRestore(data) {
  return {
    type: _user.actionTypes.BULK_SOFT_DELETE_RESTORE,
    payload: data
  };
};

/**
 * list deleted by user
 * @param payload
 * @returns api response
 * @description this function used to get user's list for deleted by.
 */
exports.userBulkSoftDeleteRestore = userBulkSoftDeleteRestore;
var userDeletedByList = function userDeletedByList(data) {
  return {
    type: _user.actionTypes.LIST_DELETED_BY_USER,
    payload: data
  };
};
exports.userDeletedByList = userDeletedByList;